import React from "react";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons";
import { withRouter } from "@ipc/ipc-core";
import {
  LoginContainer,
  Title,
  Header,
  SubTitle,
  CallToAction,
  TroubleLogging,
} from "./Login.style";
import { frontEndUrl, httpOnlySecurityService } from "../../externals/iam";

const Login = ({ location }) => {
  const intl = useIntl();
  const fromLocation = location.pathname;
  const afterLoginUrl = fromLocation
    ? `${frontEndUrl}/#${fromLocation}`
    : frontEndUrl;

  return (
    <LoginContainer>
      <Header>CAPE</Header>
      <span>
        <Title>Welcome to CAPE</Title>
      </span>
      <span>
        <SubTitle>
          Manage ICS2 &amp; Postal EDI Message flows with up-to-date
        </SubTitle>
        <SubTitle>
          information on Postal Item, Receptacle, Consignment &amp; Shipment
          levels.
        </SubTitle>
        <SubTitle>
          Ensure data exchange with stakeholders and meet regulatory
          requirements.
        </SubTitle>
      </span>
      <div style={{ display: "flex", gap: "20px" }}>
        <CallToAction
          type="button"
          onClick={() => httpOnlySecurityService.login(afterLoginUrl)}
        >
          SSO LOGIN
          <FontAwesomeIcon icon={faSignInAlt} />
        </CallToAction>
      </div>
      <TroubleLogging>
        Trouble logging in? Contact &nbsp;
        <a href="mailto:servicedesk@ipc.be">servicedesk@ipc.be</a>
        &nbsp; or &nbsp;
        <a href="https://servicedesk.ipc.be/servicedesk">
          IPC Customer Service Desk Portal
        </a>
      </TroubleLogging>
    </LoginContainer>
  );
};

export default withRouter(Login);
